// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"cbfb758d","307":"724319a5","319":"7e6dd986","379":"724319a5","666":"cbfb758d","705":"cbfb758d","916":"cbfb758d","988":"a94d1ed5"}[chunkId] + ".chunk.css";
};